import { Component, effect, OnInit } from '@angular/core';
import { AuthenticationService } from './auth/authentication-service/authentication.service';
import { ActionsService } from './services/actions-service/actions.service';
import { ConfigurationService } from './services/configuration-service/configuration.service';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatButtonModule } from '@angular/material/button';
import { BreakpointObserver } from '@angular/cdk/layout';

import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { UserAuthenticationDataManagerService } from './auth/user-authentication-data-manager-service/user-authentication-data-manager.service';
import log from 'loglevel';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [
    RouterLink,
    RouterLinkActive,
    RouterOutlet,
    MatSidenavModule,
    MatToolbarModule,
    MatIconModule,
    MatListModule,
    MatButtonModule
  ]
})
export class AppComponent implements OnInit {

  protected logger = log.getLogger('AppComponent');

  sidenavOpened = false;
  mode: 'over' | 'side' = 'side';
  isMobile = false;
  title = 'projectchrono';
  projectVersion?: string;

  userName?: string;

  constructor(
    protected configuration: ConfigurationService,
    protected authService: AuthenticationService,
    protected actionsService: ActionsService,
    protected userAuth: UserAuthenticationDataManagerService,
    private observer: BreakpointObserver
  ) {
    this.logger.info('Initializing app component');

    effect(() => {
      this.userName = authService.authData()?.username;
    })
    this.projectVersion = environment.appVersion;
  }

  ngOnInit() {
    this.observer.observe(['(max-width: 800px)']).subscribe((res) => {
      if (res.matches) {
        this.isMobile = true;
        this.mode = 'over';
        this.sidenavOpened = false;
      } else {
        this.isMobile = false;
        this.mode = 'side';
        this.sidenavOpened = true;
      }
    });
    if (!this.isMobile) {
      this.sidenavOpened = true;
    }
  }

  logOut() {
    this.authService.logout()
  }

}
